import * as React from 'react';
import { reduce, orderBy, sumBy } from 'lodash';

import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import { PriceType } from '../../classes/price-type';
import { sortPriceTypes } from '../../helpers/price-type-helpers';

import PriceTypeQuantitySelect from '../../common/selects/quantity-select';
import GroupSeatingMessage from './group-seating-message';
import { formatString } from '../../helpers/string-format';
import { getCurrencyFormat } from '../../helpers/currency-format';
import { ItemType } from '../../classes/item-type';

export interface IPriceTypeFilterContainerProps {
    appSettingsModel: IAppSettingsModel;
    onChangePriceTypeQuantity: (priceTypeId: number, quantity: number) => void;
    priceTypes: PriceType[];
    showComponent: boolean;
}

class PriceTypeFilterContainer extends React.PureComponent<IPriceTypeFilterContainerProps, any>{

    render() {
        if (!this.props.showComponent) return null;

        var hitMaxTicketLimit = sumBy(this.props.priceTypes, pt => pt.selectedQuantity) >= this.props.appSettingsModel.maxTicketQuantity;

        return (
            <section className="filters-section">
                <h2 className="heading-general">{this.props.appSettingsModel.numberOfTicketsTitle}</h2>
                <div className="filters-section-message">
                    {this.props.appSettingsModel.numberOfTicketsMessage &&
                        <p>{this.props.appSettingsModel.numberOfTicketsMessage.replace('{MaxQuantity}', this.props.appSettingsModel.maxTicketQuantity.toString())}</p>
                    }
                </div>
                {
                    this.props.appSettingsModel.groupTicketMessaging !== null && this.props.appSettingsModel.groupTicketMessaging.length > 0
                        ?
                        <GroupSeatingMessage
                            groupTicketMessaging={this.props.appSettingsModel.groupTicketMessaging}
                            alertComponent={hitMaxTicketLimit} />
                        : null
                }

                <div className="seat-info-prices-type-list">
                    {this.getSortedPriceTypes().map(priceType =>
                        <PriceTypeQuantitySelect key={priceType.priceTypeId}
                            quantity={priceType.selectedQuantity}
                            onSelectQuantity={this.props.onChangePriceTypeQuantity}
                            displayText={priceType.title}
                            priceTypeId={priceType.priceTypeId}
                            messageText={priceType.message}
                            startingAtText={this.getStartingAtText(priceType)}
                            priceTypeMaxReached={(priceType.selectedQuantity >= this.getPriceTypeMaxQuantity(priceType))}
                            priceTypeMaxError={this.props.appSettingsModel.maxQuantityPriceTypeSelectedError.replace("{0}", priceType.title)}
                            canAdd={!hitMaxTicketLimit && (priceType.selectedQuantity < this.getPriceTypeMaxQuantity(priceType))}
                            canRemove={priceType.selectedQuantity !== 0 && priceType.selectedQuantity > this.getPriceTypeMinQuantity(priceType)}
                        />
                    )}
                </div>

            </section>
        );
    }

    //_onSelectQuantity = (quantity, priceTypeId) => this.props.onChangePriceTypeQuantity(priceTypeId, quantity);

    getStartingAtText(priceType: PriceType): string {
        const priceText = getCurrencyFormat(this.props.appSettingsModel.currencyFormat, priceType.minPrice);
        const message = formatString(
            this.props.appSettingsModel.itemType === ItemType.Fixed || this.props.appSettingsModel.itemType === ItemType.Flex
                || this.props.appSettingsModel.itemType === ItemType.Super
                ?
                this.props.appSettingsModel.subscriptionFilterPackageTicketStartingPrice
                : this.props.appSettingsModel.filterTicketStartingPrice, [priceText]);
        return message;
    }

    getSortedPriceTypes() {
        return sortPriceTypes(this.props.priceTypes);
    }

    getPriceTypeMaxQuantity(priceType: PriceType): number {
        return Math.min(priceType.clientMaxQuantity, this.props.appSettingsModel.maxTicketQuantity);
    }

    getPriceTypeMinQuantity(priceType: PriceType): number {
        return priceType.clientMinQuantity;
    }
}

export default PriceTypeFilterContainer;